<script>
import calendar_mixin from "../../../mixins/calendar_mixin";
import routes_mixin from "../../../mixins/routes_mixin";
import BadgeBlock from "../../slots/BadgeBlock.vue";
import DefaultTitle from "../../small_components/DefaultTitle.vue";
import DefaultInput from "../../small_components/DefaultInput.vue";
import Loader from "../../small_components/Loader.vue";
import ChevronLeftIcon from "../../icons/ChevronLeftIcon.vue";
import InfoBlock from "../../small_components/InfoBlock.vue";
import NotifierBlock from "../../parts/NotifierBlock.vue";
import HeaderBlock from "../../parts/HeaderBlock.vue";
import AsideDashboard from "../../small_components/AsideDashboard.vue";
import Switcher from "../../small_components/Switcher.vue";
import EditIcon from "../../icons/EditIcon.vue";
import RouterLinkTo from "../../small_components/RouterLinkTo.vue";
import SearchInput from "../../small_components/SearchInput.vue";
import DefaultBox from "../../slots/DefaultBox.vue";
import TablesSlot from "../../small_components/tables/TablesSlot.vue";
import {axiosBelts, axiosBeltsCookie} from "../../../helpers/axios_requests";
import DefaultSelect from "../../small_components/DefaultSelect.vue";
import DefaultButton from "../../small_components/DefaultButton.vue";
import TextareaEditor from "../../small_components/TextareaEditor.vue";
import {ValidationObserver} from "vee-validate";
import {FORMAT_ERROR_MESSAGE} from "../../../helpers/validation_error_message";
import {STATUS_ERROR, STATUS_SUCCESS} from "../../../store/modules/notifiocation";
import {mapActions} from "vuex";

export default {
  mixins: [calendar_mixin, routes_mixin],

  name: 'BenefitLayout',
  components: {
    TextareaEditor, DefaultButton, DefaultSelect,
    BadgeBlock, DefaultTitle,
    DefaultInput,
    Loader, ChevronLeftIcon, InfoBlock,
    NotifierBlock,
    HeaderBlock,
    AsideDashboard,
    Switcher,
    EditIcon,
    RouterLinkTo,
    SearchInput,
    DefaultBox,
    TablesSlot,
    ValidationObserver
  },

  computed: {
  },
  beforeMount() {
  },

  data() {
    return {
      getUserRoleIsAdmin: true,
      loading: true,
      belt: [],
      package: [],
      cookies: [],
      selectedCookies: []
    }
  },

  created() {
    this.loading = false;
    this.fetchBelt(this.$route.params.id)
    this.fetchCookies();
  },
  methods: {
    ...mapActions([
      'actionPushNotification'
    ]),
    searchFetchList() {
      return true;
    },

    fillData(data) {
      this.belt = data || [];
      this.package = data.package
    },

    fillCookies(data) {
      this.cookies = data || [];
    },

    fetchBelt(id) {
      this.loading = true
      axiosBelts.belt(id)
          .then(r => {
            this.fillData(r.data)
          })
          .finally(() => {
            this.loading = false
          })
    },

    fetchCookies() {
      axiosBeltsCookie.pureList()
          .then(r => {
            this.fillCookies(r.data)
          })
          .finally(() => {
            this.loading = false
          })
    },

    createUpdate() {
      axiosBelts.createUpdateBenefit(this.belt).then((r) => {
        if (r.data.errors) {
          let message = FORMAT_ERROR_MESSAGE(r.data.errors)
          this.actionPushNotification(
              {message: message, status: STATUS_ERROR}
          )
          return;
        }
        this.actionPushNotification({message: 'Saved', status: STATUS_SUCCESS})
      }).catch((r) => {
        console.log(r)
      })
    },

    changeCookies(val) {
      this.belt.cookies = val;
    }
  }
}
</script>

<template>
  <div class="user-layout">
    <badge-block>
      <default-title h_tag="h3">
        {{ $t('belts.belt_info') }}
      </default-title>
      <default-box class="position-relative"
                :loader="loading">
        <div class="row dashboard-wrapper  mt-20">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="card">
              <h5 class="card-header">{{ $t('belts.belt') }} {{ belt.title }}</h5>
              <div class="card-body">
                <ValidationObserver v-slot="{ invalid, passes }" ref="form">
                  <form class="row mt-20"
                        @submit.prevent="passes(createUpdate)">
                    <div class="col-md-12 col-12 mb-10">
                      <default-input
                          :label="$t('tables.title')"
                          v-model="belt.title"
                      />
                    </div>
                    <div class="col-md-12 col-12 mb-10">
                      <default-input
                          :label="$t('belts.customer_type')"
                          v-model="belt.customer_type"
                      />
                    </div>
                    <div class="col-md-12 col-12 mb-10">
                      <default-input
                          :label="$t('belts.description')"
                          v-model="belt.description"
                      />
                    </div>
                    <div
                        class="col-md-12 col-12 mb-10">
                      <default-select
                          searchable
                          multiple
                          :placeholder="$t('belts.cookie')"
                          :selected_val="belt.cookies"
                          display_item_api_key="title"
                          :list_outer="cookies"
                          @change="changeCookies"
                      />
                    </div>
                    <div class="text-end mt-20 sticky-bottom">
                      <default-button
                          button_large
                          type="submit">
                        {{ $t('inputs.save') }}
                      </default-button>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </div>
          </div>
        </div>
      </default-box>
    </badge-block>
  </div>
</template>

<style scoped>

</style>